import {ITheme} from 'contexts/ThemeContext';
import {Platform, useWindowDimensions} from 'react-native';
import strings from 'translations/index.web';

export default ({colors, typography}: ITheme) => {
  const {width, height} = useWindowDimensions();

  return {
    defaultStyle: {},
    flex: {
      flex: 1,
    },
    safeAreaStyle: {
      flex: 1,
      backgroundColor: colors.white,
    },
    containerStyle: {
      justifyContent: Platform.OS === 'web' ? 'flex-start' : 'flex-end',
      alignItems: 'center',
      backgroundColor: colors.white,
    },
    contentContainerStyle: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      width: width,
      paddingBottom: Platform.OS === 'web' ? 5 : 0,
    },
    contentContainerStyleWeb: {
      flexDirection: 'row',
    },
    studentContainerStyle: {
      flex: 1,
      alignItems: 'center',
    },
    studentContainerWeb: {
      height: '100%',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    studentTitleStyle: {
      fontSize: 17,
      color: colors.primaryTextColor,
      ...typography.mulishBold,
    },
    studentTitleStyleWeb: {
      fontSize: 14,
      color: colors.primaryTextColor,
      ...typography.interRegular,
    },
    chartContainerStyle: {
      flex: 2,
      height: height,
      borderLeftWidth: 1,
      borderLeftColor: colors.alto,
    },
    chartContainerWeb: {
      height: '100%',
      flex: 1,
    },
    multipleChartsMargin: (index: number, tickValueArray: number[]) => ({
      flexDirection: 'column',
      alignItems: 'flex-start',
      backgroundColor: index % 2 === 0 ? colors.dirtyWhite : colors.white,
      borderWidth: 1,
      borderColor: colors.grey300,
      width: 100 * tickValueArray.length,
      height: 48,
    }),
    scrollViewContentContainerStyle: {
      justifyContent: 'center',
      alignItems: 'flex-end',
      paddingTop: Platform.OS === 'web' ? 70 : 0,
    },

    scrollViewContentContainerStyleWeb: {
      justifyContent: 'center',
      alignItems: 'flex-start',
      flexDirection: 'column',
      height: '100%',
    },

    defaultChartValueStyle: {
      position: 'absolute',
      bottom: 26,
      height: 166,
    },
    defaultChartValueStyleWeb: (chartType: string) => ({
      position: 'absolute',
      bottom: chartType === strings.analyticsScreen.speakers ? 21 : 10,
    }),
    speakerBarStyle: (
      domain: number,
      propsStartOffset: number,
      basicStartOffset: number,
      propsEndOffset: number,
    ) => ({
      left: domain * propsStartOffset - basicStartOffset,
      alignItems: 'center',
      width: (propsEndOffset - propsStartOffset) * domain,
      borderStyle: 'dashed',
      borderWidth: Platform.OS === 'web' ? 0 : 1,
      borderColor: colors.heliotrope,
    }),
    beforeViewStyle: {
      marginTop: -5,
      width: '100%',
      height: Platform.OS === 'web' ? 6 : 11,
      borderRadius: 6,
      backgroundColor: colors.heliotrope,
    },
    gradientBarStyle: {
      height: '100%',
      width: '100%',
    },
    reactionBarStyle: (
      domain: number,
      propsStartOffset: number,
      basicStartOffset: number,
    ) => ({
      left:
        Platform.OS === 'web'
          ? domain * propsStartOffset - basicStartOffset - 15
          : domain * propsStartOffset - basicStartOffset,
    }),

    reactionSize: {
      fontSize: 28,
    },

    studentListContainerStyle: {
      paddingTop: 60,
      width: '100%',
      height: 320,
      paddingBottom: 0,
    },

    studentListContainerStyleWeb: {
      width: '100%',
      paddingBottom: 0,
    },

    studentContentContainerStyle: {
      width: Platform.OS === 'web' ? 200 : '100%',
      shadowColor: colors.white,
    },
    studentItemContainerStyle: {
      justifyContent: 'center',
      alignItems: Platform.OS === 'web' ? 'flex-start' : 'center',
      paddingHorizontal: Platform.OS === 'web' ? 10 : 5,
      paddingVertical: 5,
      borderBottomWidth: Platform.OS === 'web' ? 1 : 0,
      borderRightWidth: Platform.OS === 'web' ? 1 : 0,
      borderColor: colors.extraLight,
      backgroundColor: colors.dirtyWhite,
      height: 48,
    },
    studentItemSeparatorStyle: {
      height: Platform.OS === 'web' ? 0 : 10,
      backgroundColor: colors.white,
    },
    borderRadius: {
      height: '100%',
      borderRadius: 0,
    },
    scrollViewStyle: {
      width: width - 270,
    },
    attentionContainerStyle: {
      width: '100%',
      height: height - 120,
    },
  };
};
